import React from 'react';
import { Tag } from 'core/components';
import { GeneralIndicatorProps, Intent } from 'core/components/types';

const ICON_MAP: Partial<Record<Intent, string>> = {
  success: 'tick',
  warning: 'warning-sign',
  severe: 'warning-sign',
  danger: 'error',
  none: 'circle'
};

const GeneralIndicator = ({
  intent = 'none',
  text,
  title,
  onClick,
  round,
  interactive = true,
  hideIconForNone = false,
  fontWeight
}: GeneralIndicatorProps) => {
  const weight = fontWeight || (intent === 'none' ? 'normal' : 'bold');
  const shouldShowIcon = !(hideIconForNone && intent === 'none');
  const icon = shouldShowIcon ? ICON_MAP[intent] : undefined;
  const iconProps =
    intent === 'none'
      ? // we need to ensure that the indicator size remains the same regardless of state, so we'll add a little extra margin to consume space
        // don't ask where the extra 1px comes from, I have no idea. it's convenient though since it makes the extra spacing even!
        { iconSize: 9, ml: '3px', mr: '7px' }
      : { iconSize: 14 };

  return (
    <Tag
      intent={intent}
      icon={icon}
      iconProps={iconProps}
      minimal
      fontWeight={weight}
      title={title}
      round={round}
      interactive={interactive}
      onClick={onClick}
    >
      {text}
    </Tag>
  );
};
export default GeneralIndicator;
